/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateUserActionTypes, UpdateUserActions } from './action';
import { User } from '../../getUser/redux/action';

export interface UpdateUserState {
  isUpdateUserModalOpen: boolean;
  isUserUpdated: boolean;
  isUserUpdateFailed: boolean;
  photo: any;
  name: string;
  lastname: string;
  phoneNumber: string;
  isUpdateUserLoading: boolean;
  updatedUser: User;
  error: string;
}

export const initialUpdateUserState: UpdateUserState = {
  isUpdateUserModalOpen: false,
  isUserUpdated: false,
  isUserUpdateFailed: false,
  photo: undefined,
  name: '',
  lastname: '',
  phoneNumber: '',
  isUpdateUserLoading: false,
  updatedUser: {
    id: '',
    username: '',
    email: '',
    avatar: '',
    groupName: 0,
    joinDate: 0,
    status: null,
    phoneNumber: '',
    point: 0,
    __typename: null,
  },
  error: '',
};

export function updateUserReducer(state = initialUpdateUserState, action: UpdateUserActions) {
  switch (action.type) {
    case UpdateUserActionTypes.OPEN_UPDATE_USER_MODAL:
      return update(state, {
        isUpdateUserModalOpen: { $set: true },
      });
    case UpdateUserActionTypes.CLOSE_UPDATE_USER_MODAL:
      return update(state, {
        isUpdateUserModalOpen: { $set: false },
        updatedUser: { $set: null },
        isUserUpdated: { $set: false },
        isUserUpdateFailed: { $set: false },
      });
    case UpdateUserActionTypes.AVATAR_INPUT:
      return update(state, {
        photo: { $set: action.photo },
      });
    case UpdateUserActionTypes.NAME_INPUT:
      return update(state, {
        name: { $set: action.name },
      });
    case UpdateUserActionTypes.LASTNAME_INPUT:
      return update(state, {
        lastname: { $set: action.lastname },
      });
    case UpdateUserActionTypes.PHONE_INPUT:
      return update(state, {
        phoneNumber: { $set: action.phone },
      });
    case UpdateUserActionTypes.UPDATE_USER_REQUEST:
      return update(state, {
        isUpdateUserLoading: { $set: true },
      });
    case UpdateUserActionTypes.UPDATE_USER_SUCCEEDED:
      return update(state, {
        isUpdateUserLoading: { $set: false },
        updatedUser: { $set: action.user },
        isUserUpdated: { $set: true },
      });
    case UpdateUserActionTypes.UPDATE_USER_FAILED:
      return update(state, {
        isUpdateUserLoading: { $set: false },
        updatedUser: { $set: null },
        isUserUpdateFailed: { $set: true },
      });
    default:
      return state;
  }
}
